import React from 'react';
import PropTypes from 'prop-types';
import {Animated} from "react-animated-css";
import Lock from "-!svg-react-loader!./assets/img/lock.svg?name=Lock";
import './styles.scss';

class Spinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: props.time,
      isRunning: false,
      hadFinish: false,
    };

    this.tick = this.tick.bind(this);
  }

  tick() {
    if (!this.state.isRunning) this.setState({ isRunning: true });

    if (this.state.time > 0) {
      this.setState({ time: this.state.time - 1 });
    } else {
      //this.props.hideLoader();
      clearInterval(this.timer);
      this.setState({ hadFinish: true });
    }
  }

  componentDidMount() {
   // this.setState({ isServer: typeof window !== 'undefined' });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
   /* const { hadFinish } = this.state;
    if (hadFinish && prevProps.loader !== this.props.loader) {
      this.setState({
        time: this.props.time,
        isRunning: false,
      });
    } */
  }

  render() {
    const { loader } = this.props;
    const { time, isRunning } = this.state;
 /*   if (loader && !isRunning) {
      this.timer = setInterval(this.tick, 1000);
    }

    if (!loader) return null;
*/
    return (
      <div id="Spinner">
        <Animated
          animationIn="zoomIn"
          animationOut="zoomOut"
          isVisible
          animationInDuration={0}
          animationOutDuration={2000}
        >
          <span className="spin" />
          <span className="sub-title">
            Stiamo inoltrando la tua richiesta al nostro Assistente Virtuale...{' '}
          </span>
          <div className="content"/>
        </Animated>
      </div>
    );
  }
}


export default Spinner;
